import React from 'react'
import { Box, Paper, Stack, Typography } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { formatDuration } from '@e3dc-react/shell/Libs/date'
import { BZTime } from '@e3dc-react/icons'
import { useStatCardStyles } from './stat-card.styles'

const useStyles = makeStyles()(theme => ({
  iconBackground: {
    backgroundColor: theme.palette.chart.chargeDurationCardBackground,
  },
  icon: {
    color: theme.palette.primary.dark,
  },
}))

interface ChargeDurationCardProps {
  chargeDurationMilliseconds: number
}

export const ChargeDurationCard: React.VFC<ChargeDurationCardProps> = ({ chargeDurationMilliseconds }) => {
  const { t } = useCustomTranslation()
  const { classes, cx } = useStyles()
  const { classes: statCardClasses } = useStatCardStyles()

  return (
    <Paper className={statCardClasses.card}>
      <Stack direction="row" spacing={2}>
        <Box className={cx(statCardClasses.circularContainer, classes.iconBackground)}>
          <BZTime fontSize="large" className={classes.icon} />
        </Box>

        <Stack justifyContent="space-between">
          <Box>
            <Typography variant="subtitle2">{t('emobility.chargingSession.chargeDuration')}</Typography>
          </Box>
          <Box>
            <Typography variant="h2">{formatDuration(chargeDurationMilliseconds)}</Typography>
          </Box>
        </Stack>
      </Stack>
    </Paper>
  )
}
